import { useEffect, useState } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'
import * as fetchs from '../fetchs'
import * as lib from '../lib'
import * as state from '../states'
import {
	type ITokensState,
	type IFetchItems,
	type IFetchItemsSetup,
	type INoFetch,
	type TOfferSpendByOfferScope,
} from '../types'

type IUseOfferSpendByOfferScopeList = {
	error: INoFetch | null;
	items: TOfferSpendByOfferScope[];
	total: number;
	warmUp: () => void;
}

export function useOfferSpendByOfferScopeList(
	setup: IFetchItemsSetup,
	send: boolean
): IUseOfferSpendByOfferScopeList {
	const tokens: ITokensState = useAtomValue(state.tokensAtom)
	const setFetchIsLoading = useSetAtom(state.fetchIsLoadingAtom)

	const [error, setError] = useState<INoFetch | null>(null)
	const [items, setItems] = useState<Array<TOfferSpendByOfferScope>>([])
	const [total, setTotal] = useState<number>(0)
	const [warmUpIt, setWarmUpIt] = useState<number>(0)
	const filter = lib.filterSetup([...setup?.filter ?? []])
	//console.log('useOfferSpendByOfferScopeList:: ', { sort: setup?.sort })
	const sort = lib.sortSetup([...setup?.sort ?? []])
	const skip = lib.skipSetup(setup?.skip)
	const take = lib.takeSetup(setup?.take)
	const access = tokens?.access ?? null
	const warmUp = () => setWarmUpIt(warmUpIt + 1)

	useEffect(() => {
		const controller = new AbortController()
		const signal = controller.signal

		const call = async () => {
			try {
				setFetchIsLoading(state.turnOnLoader)
				const res = await fetchs.listOfferSpendByOfferScope(filter, sort, skip, take, signal, access)
				const { items, total }: IFetchItems<TOfferSpendByOfferScope> = res
				setError(null)
				setItems(items)
				setTotal(total)
			} catch (error: unknown) {
				setError(error as INoFetch)
				setItems([])
				setTotal(0)
			} finally {
				setFetchIsLoading(state.turnOffLoader)
			}
		}

		send && call()

		return () => {
			controller.abort()
		}
	}, [
		setFetchIsLoading,
		send,
		filter, sort,
		skip, take,
		access,
		warmUpIt
	])

	return { error, items, total, warmUp }
}
